@if (visible) {
  <div class="preview-overlay" (click)="closed.emit()">
    <section class="preview-modal" (click)="$event.stopPropagation()">
      <header class="preview-header">
        <div class="preview-heading">
          <div class="card-icon" [ngClass]="report.color">
            <i [class]="icon"></i>
          </div>
          <div>
            <h2>{{ title }}</h2>
            <p>{{ description }}</p>
          </div>
        </div>

        <button type="button" class="icon-close" (click)="closed.emit()" aria-label="Fechar">
          <i class="pi pi-times"></i>
        </button>
      </header>

      <div class="preview-table">
        <table>
          <thead>
            <tr>
              @for (column of columns; track column.key) {
                <th>{{ column.label }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of rows | slice:0:6; track $index) {
              <tr>
                @for (column of columns; track column.key) {
                  <td>{{ row[column.key] }}</td>
                }
              </tr>
            } @empty {
              <tr>
                <td [attr.colspan]="columns.length" class="empty-cell">
                  Não existem dados reais disponíveis para os filtros seleccionados.
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <footer class="preview-footer">
        <span>
          Mostra {{ totalRecords > 6 ? 'os primeiros 6 de ' : '' }}{{ totalRecords }} registos
        </span>
        <div>
          <button type="button" class="btn btn-ghost" (click)="closed.emit()">Fechar</button>
          <button type="button" class="btn btn-primary"
            (click)="downloadRequested.emit()" [disabled]="generating">
            <i class="pi" [ngClass]="generating ? 'pi-spin pi-spinner' : 'pi-download'"></i>
            {{ generating ? 'A gerar...' : 'Descarregar' }}
          </button>
        </div>
      </footer>
    </section>
  </div>
}